export const GET_EVENTS_LOCKER_LIST_REQUEST = 'GET_EVENTS_LOCKER_LIST_REQUEST';
export const GET_EVENTS_LOCKER_LIST_SUCCESS = 'GET_EVENTS_LOCKER_LIST_SUCCESS';
export const GET_EVENTS_LOCKER_LIST_FAILURE = 'GET_EVENTS_LOCKER_LIST_FAILURE';
export const RESET_EVENTS_LOCKER_LIST_STATE = 'RESET_EVENTS_LOCKER_LIST_STATE';
